import React from "react";
import { PageMessage } from "@picklebet/ui";
import { SupportLink } from "@/features/shell/components/shared/SupportLink";

import { ReactComponent as ErrorIcon } from "assets/illustrations/account-error.svg";

/**
 * Shown for a non-GRANTED deposit permission that `CheckPermissions` has no
 * dedicated screen for
 */
const DepositUnavailable = () => (
  <PageMessage
    image={<ErrorIcon />}
    title="Deposits are unavailable"
    subTitle="We can't process a deposit on your account right now."
  >
    <SupportLink openLiveChat type="button">
      Contact Support
    </SupportLink>
  </PageMessage>
);

export { DepositUnavailable };
